import { type KalosLogoVariant } from '@kalos/ui';
import { useQuery } from '@tanstack/react-query';
import { kalosLogoQueryOptions } from 'kalos-modules';

import { ENDPOINT } from '../../constants';
import { queryClient } from '../../tools/queryClient';

export const useKalosLogoQuery = (variant: KalosLogoVariant = 'default') =>
  useQuery(kalosLogoQueryOptions(ENDPOINT, variant));

export const getKalosLogoUrl = (variant: KalosLogoVariant = 'default') =>
  queryClient.ensureQueryData(kalosLogoQueryOptions(ENDPOINT, variant));

void queryClient.prefetchQuery(kalosLogoQueryOptions(ENDPOINT, 'onDark'));
